import { Box, FormControl, FormControlLabel, FormGroup, Stack, Switch, SwitchProps, Typography } from '@mui/material';
import React from 'react';

interface IProps {
    label?: React.ReactNode;
    helperText?: string | React.ReactNode;
    secondayAction?: React.ReactNode;
    children?: React.ReactNode;
    margin?: MuiMargin;
    noWrap?: boolean;
}

export type MprcSwitchProps = IProps & SwitchProps;

export const MprcSwitch: React.FC<MprcSwitchProps> = ({ margin, label, helperText, children, secondayAction, noWrap = true, ...rest }) => {

    if (label == undefined)
        return <Switch {...rest}>{children}</Switch>;

    const RenderLabel = (
        <>
            {
                secondayAction != undefined ?
                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                        <div>{label}</div>
                        {secondayAction}
                    </Stack>
                    :
                    label
            }
        </>
    );

    return (
        <FormGroup>
            <FormControl margin={margin} >
                <FormControlLabel
                    control={<Switch {...rest} />}
                    label={RenderLabel}
                    disabled={rest.disabled}
                    slotProps={
                        {
                            typography: { width: "100%", noWrap: noWrap }
                        }
                    }
                />
                {
                    (helperText != undefined || children != undefined) &&
                    <Box sx={{ ml: 6, mt: -1 }}>
                        {helperText && <Typography variant="caption" component="p">{helperText}</Typography>}
                        {children}
                    </Box>
                }
            </FormControl>
        </FormGroup>
    );
};
